import {visualisationData, visualisationDataForBars} from "../../data/visualisation-data";

import React, {FunctionComponent, useMemo} from 'react';
import {ChartProps} from "../../models/chart-selector-props.interface";
import ClusterChart from "../cluster-chart/ClusterChart";
import BarChart from "../bar-chart/BarChart";
import {makeDataGroup} from "../../helpers/make-data-group";

const ChartContainer: FunctionComponent<ChartProps> = (
    {
        dataType,
        prep,
        chartType,
    }) => {

    const dataGroupBubbles = useMemo(() => {
        return visualisationData.map((d, i) =>
            makeDataGroup(prep, dataType, visualisationData, i)
        );
    }, [dataType, prep]);

    const dataGroupBars = useMemo(() => {
        return visualisationDataForBars.map((d, i) =>
            makeDataGroup(prep, dataType, visualisationDataForBars, i)
        );
    }, [dataType, prep]);

    return (
        <>
            {
                chartType === "cluster"
                    ? <ClusterChart dataGroup={dataGroupBubbles}/>
                    : <BarChart dataGroup={dataGroupBars}/>
            }
        </>
    );
}

export default ChartContainer;
